import clsx from 'clsx';

import { BarDataPoint } from '../vertical-bar/VerticalBar';
import styles from './Legend.module.scss';

export interface LegendProps {
  title?: string;
  data: BarDataPoint[];
  formatValue: (value: number) => string;
  hoveredLabel: string;
}

export const Legend = ({
  title,
  data,
  formatValue,
  hoveredLabel,
}: LegendProps) => {
  const filteredData = data.filter(d => d.label);
  return (
    <div className={styles.legendRoot} data-testid="legend">
      {!!title && <p className={styles.title}>{title}</p>}
      <div className={styles.list}>
        {filteredData.map(item => (
          <div
            className={clsx(styles.item, {
              [styles.itemHovered]: item.label === hoveredLabel,
            })}
            key={item.label}
          >
            <div className={styles.asset}>
              <div
                className={styles.dot}
                style={item.color ? { backgroundColor: item.color } : undefined}
              />
              <span className={styles.label}>{item.label}</span>
            </div>
            <span className={styles.value}>
              {item.value !== undefined ? formatValue(item.value) : 'N/A'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
